import React, { useEffect, useRef } from 'react';
import { View } from '../../../View';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
import { Animated, Platform } from 'react-native';
export const Dots = ({ style }) => {
    const styles = useStyleSheet(getStyles);
    const dot_01 = useRef(new Animated.Value(1)).current;
    const dot_02 = useRef(new Animated.Value(1)).current;
    const dot_03 = useRef(new Animated.Value(1)).current;
    useEffect(() => {
        Animated.loop(Animated.sequence([
            Animated.timing(dot_01, {
                toValue: 1.25,
                duration: 200,
                useNativeDriver: Platform.OS !== 'web'
            }),
            Animated.parallel([
                Animated.timing(dot_01, {
                    toValue: 1.75,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                }),
                Animated.timing(dot_02, {
                    toValue: 1.25,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                })
            ]),
            Animated.parallel([
                Animated.timing(dot_01, {
                    toValue: 1.25,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                }),
                Animated.timing(dot_02, {
                    toValue: 1.75,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                }),
                Animated.timing(dot_03, {
                    toValue: 1.25,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                })
            ]),
            Animated.parallel([
                Animated.timing(dot_01, {
                    toValue: 1,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                }),
                Animated.timing(dot_02, {
                    toValue: 1.25,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                }),
                Animated.timing(dot_03, {
                    toValue: 1.75,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                })
            ]),
            Animated.parallel([
                Animated.timing(dot_02, {
                    toValue: 1,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                }),
                Animated.timing(dot_03, {
                    toValue: 1.25,
                    duration: 200,
                    useNativeDriver: Platform.OS !== 'web'
                })
            ]),
            Animated.timing(dot_03, {
                toValue: 1,
                duration: 200,
                useNativeDriver: Platform.OS !== 'web'
            })
        ]), {}).start();
    }, []);
    return (React.createElement(View, { style: [styles.container, style] },
        React.createElement(Animated.View, { style: [styles.dot, { transform: [{ scale: dot_01 }] }] }),
        React.createElement(Animated.View, { style: [
                styles.dot,
                styles.dot__withMargin,
                { transform: [{ scale: dot_02 }] }
            ] }),
        React.createElement(Animated.View, { style: [
                styles.dot,
                styles.dot__withMargin,
                { transform: [{ scale: dot_03 }] }
            ] })));
};
const getStyles = createStyleSheet(({ color, size }) => ({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        width: size.I,
        height: size.I
    },
    dot: {
        width: 3,
        height: 3,
        borderRadius: 9999,
        backgroundColor: color.invert2.p68
    },
    dot__withMargin: {
        marginLeft: 3
    }
}));
//# sourceMappingURL=Dots.js.map